import { ChartAvg } from "assets/icons/ChartAvg";
import { ChartDown } from "assets/icons/ChartDown";
import { ChartUp } from "assets/icons/ChartUp";
import * as XLSX from "xlsx";

export const topResultsAmountOptions = [
  { label: "Top 10 CPT Codes", value: 10 },
  { label: "Top 100 CPT Codes", value: 100 },
];

export function exportToCSV(data: any[], filename: string) {
  if (!data.length) return;

  const headers = Object.keys(data[0]);
  const rows = data.map((row) =>
    headers.map((header) => JSON.stringify(row[header] ?? "")).join(",")
  );

  const csvContent = [headers.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function exportToExcel(data: any[], filename: string) {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "FeeSchedule");

  // Write file
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export const optionsToCompareRates = [
  {
    label: "Highest Avg Commercial Rate",
    value: "maxCommercialAverage",
    icon: ChartUp,
  },
  {
    label: "Lowest Avg Commercial Rate",
    value: "minCommercialAverage",
    icon: ChartDown,
  },
  {
    label: "Medicare Avg Rate",
    value: "medicareAverage",
    icon: ChartAvg,
  },
  {
    label: "Avg Commercial Rate",
    value: "averagePriceOfferedAccrossPayers",
    icon: ChartAvg,
  },
  {
    label: "Market Average Rate",
    value: "marketAverage",
    icon: ChartAvg,
  },
];

export const comparisonRateCode = [
  {
    leftSide: "maxCommercialAverage",
    rightSide: "minCommercialAverage",
    rateToShow: "highestVsLowestCommercial",
  },
  {
    leftSide: "maxCommercialAverage",
    rightSide: "medicareAverage",
    rateToShow: "highestVsMedicare",
  },
  {
    leftSide: "maxCommercialAverage",
    rightSide: "averagePriceOfferedAccrossPayers",
    rateToShow: "highestVsAverage",
  },
  {
    leftSide: "minCommercialAverage",
    rightSide: "maxCommercialAverage",
    rateToShow: "lowestVsHighestCommercial",
  },
  {
    leftSide: "minCommercialAverage",
    rightSide: "medicareAverage",
    rateToShow: "lowestVsMedicare",
  },
  {
    leftSide: "minCommercialAverage",
    rightSide: "averagePriceOfferedAccrossPayers",
    rateToShow: "lowestVsAverage",
  },
  {
    leftSide: "medicareAverage",
    rightSide: "maxCommercialAverage",
    rateToShow: "medicareVsHighest",
  },
  {
    leftSide: "medicareAverage",
    rightSide: "minCommercialAverage",
    rateToShow: "medicareVsLowest",
  },
  {
    leftSide: "medicareAverage",
    rightSide: "averagePriceOfferedAccrossPayers",
    rateToShow: "medicareVsAverage",
  },
  {
    leftSide: "averagePriceOfferedAccrossPayers",
    rightSide: "maxCommercialAverage",
    rateToShow: "averageVsHighest",
  },
  {
    leftSide: "averagePriceOfferedAccrossPayers",
    rightSide: "minCommercialAverage",
    rateToShow: "averageVsLowest",
  },
  {
    leftSide: "averagePriceOfferedAccrossPayers",
    rightSide: "medicareAverage",
    rateToShow: "averageVsMedicare",
  },
  // Market average comparisons
  {
    leftSide: "marketAverage",
    rightSide: "maxCommercialAverage",
    rateToShow: "marketVsHighest",
  },
  {
    leftSide: "marketAverage",
    rightSide: "minCommercialAverage",
    rateToShow: "marketVsLowest",
  },
  {
    leftSide: "marketAverage",
    rightSide: "medicareAverage",
    rateToShow: "marketVsMedicare",
  },
  {
    leftSide: "marketAverage",
    rightSide: "averagePriceOfferedAccrossPayers",
    rateToShow: "marketVsAverage",
  },
  {
    leftSide: "maxCommercialAverage",
    rightSide: "marketAverage",
    rateToShow: "highestVsMarket",
  },
  {
    leftSide: "minCommercialAverage",
    rightSide: "marketAverage",
    rateToShow: "lowestVsMarket",
  },
  {
    leftSide: "medicareAverage",
    rightSide: "marketAverage",
    rateToShow: "medicareVsMarket",
  },
  {
    leftSide: "averagePriceOfferedAccrossPayers",
    rightSide: "marketAverage",
    rateToShow: "averageVsMarket",
  },
];

export const matchModeOptions = [
  { label: "Equals", value: "equals" },
  { label: "Not Equals", value: "notEquals" },
  { label: "Greater Than", value: "gt" },
  { label: "Less Than", value: "lt" },
  { label: "Greater Than or Equal To", value: "gte" },
  { label: "Less Than or Equal To", value: "lte" },
];
